import React from "react";
import image2 from "../image/image2.png";
const HomePage = () => {
  return (
    <div className="bg-slate-50 text-slate-800">

    {/* ================= WHAT WE DO ================= */}
<section className="max-w-7xl mx-auto px-6 py-16">
  <h2 className="text-3xl font-semibold text-center mb-16">
    What We Do
  </h2>

  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
    {[
      {
        title: "Policy Analysis",
        icon: "📄", // replace with logo image if needed
        points: [
          "Analyse and assess public health policies",
          "Evaluate policy impact and effectiveness",
          "Provide evidence-based insights",
        ],
      },
      {
        title: "Government Advisory",
        icon: "🏛️",
        points: [
          "Offer strategic recommendations to policymakers",
          "Produce advisories grounded in research",
          "Assist in shaping effective public health policies",
        ],
      },
      {
        title: "Public Health Dialogues",
        icon: "🧑‍🤝‍🧑",
        points: [
          "Facilitate inclusive discussions on health challenges",
          "Engage diverse stakeholders and experts",
          "Bridge the gap between the government and public",
        ],
      },
      {
        title: "Global Diaspora Engagement",
        icon: "🌍",
        points: [
          "Mobilise diaspora experts for policy input",
          "Incorporate global perspectives into local issues",
          "Strengthen international collaborations",
        ],
      },
    ].map((item, i) => (
      <div
        key={i}
        className="relative bg-white rounded-xl shadow-sm pt-14 p-6 hover:shadow-md transition"
      >
        {/* Icon / Logo */}
        <div className="absolute -top-7 left-1/2 -translate-x-1/2">
          <div className="w-14 h-14 rounded-full bg-blue-900 text-white flex items-center justify-center text-2xl shadow-md">
            {item.icon}
          </div>
        </div>

        <h3 className="text-lg font-semibold mb-4 text-center">
          {item.title}
        </h3>

        <ul className="space-y-2 text-sm text-slate-600">
          {item.points.map((p, idx) => (
            <li key={idx}>• {p}</li>
          ))}
        </ul>
      </div>
    ))}
  </div>

  <div className="text-center mt-12">
    <button className="bg-blue-900 text-white px-6 py-2 rounded-md">
      View All Dialogues
    </button>
  </div>
</section>

     
   {/* ================= RECENT POLICY DIALOGUES ================= */}
<section
  className="relative bg-cover bg-center bg-no-repeat py-20"
  style={{ backgroundImage: `url(${image2})` }}
>
  <div className="max-w-7xl mx-auto px-6">
    <div className="grid lg:grid-cols-3 gap-10">

      {/* ================= LEFT CONTENT ================= */}
      <div className="lg:col-span-2 space-y-6">
        <h2 className="text-2xl font-semibold">
          Recent Policy Dialogues
        </h2>

        {/* Policy Brief */}
        <div className="bg-white p-5 rounded-lg shadow-sm">
          <div className="flex gap-3">
            <span className="text-blue-900 text-xl">➜</span>
            <div>
              <h4 className="font-semibold text-blue-900">
                Policy Brief: Strengthening Primary Healthcare Systems
              </h4>
              <p className="text-sm text-slate-600 mt-2">
                An in-depth analysis highlighting how global diaspora expertise
                contributes to strengthening national healthcare policy
                frameworks and decision-making.
              </p>
            </div>
          </div>
        </div>

        {/* Recommendations */}
        <div className="bg-white p-5 rounded-lg shadow-sm">
          <div className="flex gap-3">
            <span className="text-orange-500 text-xl">➜</span>
            <div>
              <h4 className="font-semibold text-orange-500">
                Recommendations: Enhancing Public Health Surveillance
              </h4>
              <p className="text-sm text-slate-600 mt-2">
                An in-depth analysis highlighting how global diaspora expertise
                contributes to strengthening national healthcare policy
                frameworks and decision-making.
              </p>
            </div>
          </div>
        </div>

        {/* Research Paper */}
        <div className="bg-white p-5 rounded-lg shadow-sm">
          <div className="flex gap-3">
            <span className="text-blue-900 text-xl">➜</span>
            <div>
              <h4 className="font-semibold text-blue-900">
                Research Paper: Diaspora’s Role in Health Policy
              </h4>
              <p className="text-sm text-slate-600 mt-2">
                An in-depth analysis highlighting how global diaspora expertise
                contributes to strengthening national healthcare policy
                frameworks and decision-making.
              </p>
            </div>
          </div>
        </div>

        <button className="bg-blue-900 text-white px-6 py-2 rounded-md mt-2">
          View All Dialogues
        </button>
      </div>

      {/* ================= RIGHT STATS ================= */}
      <div className="bg-white rounded-xl shadow-sm p-6 text-center self-start lg:mt-80">
        <div className="grid grid-cols-3 gap-4">
          <div>
            <h3 className="text-3xl font-bold text-blue-900">40+</h3>
            <p className="text-sm text-slate-600">Countries Represented</p>
          </div>
          <div>
            <h3 className="text-3xl font-bold text-blue-900">300+</h3>
            <p className="text-sm text-slate-600">Global Health Experts</p>
          </div>
          <div>
            <h3 className="text-3xl font-bold text-blue-900">150+</h3>
            <p className="text-sm text-slate-600">Policy Recommendations</p>
          </div>
        </div>

        <button className="bg-blue-900 text-white px-6 py-2 rounded-md mt-8">
          View All Publications
        </button>
      </div>

    </div>
  </div>
</section>



    {/* ================= GLOBAL PRESENCE ================= */}
<section className="max-w-7xl mx-auto px-6 py-16 grid lg:grid-cols-2 gap-12 items-center">

  {/* ================= LEFT IMAGE (SMALL WITH TEXT) ================= */}
 <div className="rounded-xl overflow-hidden shadow-sm max-w-md mx-auto bg-white">

  {/* Top Half – Image */}
  <img
    src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d"
    alt="Global Dialogue"
    className="w-full h-56 object-cover"
  />

  {/* Bottom Half – Text */}
  <div className="p-6">
    <h3 className="text-blue-900 text-xl font-semibold mb-2">
      Global Health Dialogue
    </h3>
    <p className="text-sm text-slate-700 leading-relaxed">
      Connecting global diaspora expertise with national health priorities
      to strengthen policy frameworks and collaborative action.
    </p>
  </div>

</div>


  {/* ================= RIGHT CONTENT ================= */}
  <div>
    <h2 className="text-2xl font-semibold mb-6">
      Global Presence and Diaspora Engagement
    </h2>

    <div className="space-y-4">

      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex gap-3">
          <span className="text-orange-500 text-xl">➜</span>
          <div>
            <h4 className="font-medium text-blue-900">
              Policies to Tackle Rising Diabetes Cases
            </h4>
            <p className="text-sm text-slate-600 mt-1">
              Evidence-driven recommendations to address the growing burden of diabetes.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex gap-3">
          <span className="text-blue-900 text-xl">➜</span>
          <div>
            <h4 className="font-medium text-blue-900">
              India’s New Mental Health Bill
            </h4>
            <p className="text-sm text-slate-600 mt-1">
              An analysis of implications for public health systems.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex gap-3">
          <span className="text-orange-500 text-xl">➜</span>
          <div>
            <h4 className="font-medium text-blue-900">
              Upcoming Global Health Summit Insights
            </h4>
            <p className="text-sm text-slate-600 mt-1">
              Key themes and policy priorities shaping global health.
            </p>
          </div>
        </div>
      </div>

    </div>

    <button className="bg-blue-900 text-white px-6 py-2 rounded-md mt-6">
      View All News
    </button>
  </div>

</section>

    </div>
  );
};

export default HomePage;
